/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  TenantResponse,
  WebApiAdminDtoAdminDashboardDto,
  WebApiAdminDtoCreateUserDto,
  WebApiAdminDtoInvoiceGenerationRequest,
  WebApiAdminDtoSetSubscriptionDto,
  WebApiAdminDtoSetUserAsAdminDto,
  WebApiAdminDtoUserListResultDto,
  WebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequest,
  WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto,
} from '../models';
import {
    TenantResponseFromJSON,
    TenantResponseToJSON,
    WebApiAdminDtoAdminDashboardDtoFromJSON,
    WebApiAdminDtoAdminDashboardDtoToJSON,
    WebApiAdminDtoCreateUserDtoFromJSON,
    WebApiAdminDtoCreateUserDtoToJSON,
    WebApiAdminDtoInvoiceGenerationRequestFromJSON,
    WebApiAdminDtoInvoiceGenerationRequestToJSON,
    WebApiAdminDtoSetSubscriptionDtoFromJSON,
    WebApiAdminDtoSetSubscriptionDtoToJSON,
    WebApiAdminDtoSetUserAsAdminDtoFromJSON,
    WebApiAdminDtoSetUserAsAdminDtoToJSON,
    WebApiAdminDtoUserListResultDtoFromJSON,
    WebApiAdminDtoUserListResultDtoToJSON,
    WebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequestFromJSON,
    WebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequestToJSON,
    WebApiServicesDataTransferObjectsUserServiceAuthenticateResDtoFromJSON,
    WebApiServicesDataTransferObjectsUserServiceAuthenticateResDtoToJSON,
} from '../models';

export interface ApiAdminCreateUserPostRequest {
    webApiAdminDtoCreateUserDto?: WebApiAdminDtoCreateUserDto;
}

export interface ApiAdminDeleteAllMemberFieldsDeleteRequest {
    companyId?: number;
}

export interface ApiAdminDeleteAllMembersDeleteRequest {
    companyId?: number;
}

export interface ApiAdminGenerateInvoicePdfPostRequest {
    webApiAdminDtoInvoiceGenerationRequest?: WebApiAdminDtoInvoiceGenerationRequest;
}

export interface ApiAdminSetNewSubscriptionLevelPostRequest {
    companyId?: number;
    webApiAdminDtoSetSubscriptionDto?: WebApiAdminDtoSetSubscriptionDto;
}

export interface ApiAdminSetUserAsAdminPostRequest {
    webApiAdminDtoSetUserAsAdminDto?: WebApiAdminDtoSetUserAsAdminDto;
}

export interface ApiAdminUpdateTenantPutRequest {
    webApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequest?: WebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequest;
}

/**
 * 
 */
export class AdminApi extends runtime.BaseAPI {

    /**
     * Creates a new active user account and company without sending activation email.
     */
    async apiAdminCreateUserPostRaw(requestParameters: ApiAdminCreateUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/CreateUser`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiAdminDtoCreateUserDtoToJSON(requestParameters.webApiAdminDtoCreateUserDto),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Creates a new active user account and company without sending activation email.
     */
    async apiAdminCreateUserPost(requestParameters: ApiAdminCreateUserPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.apiAdminCreateUserPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the admin dashboard with system overview, integration status, batch jobs, and error logs
     */
    async apiAdminDashboardGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiAdminDtoAdminDashboardDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/Dashboard`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiAdminDtoAdminDashboardDtoFromJSON(jsonValue));
    }

    /**
     * Gets the admin dashboard with system overview, integration status, batch jobs, and error logs
     */
    async apiAdminDashboardGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiAdminDtoAdminDashboardDto> {
        const response = await this.apiAdminDashboardGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async apiAdminDeleteAllMemberFieldsDeleteRaw(requestParameters: ApiAdminDeleteAllMemberFieldsDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.companyId !== undefined) {
            queryParameters['companyId'] = requestParameters.companyId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/DeleteAllMemberFields`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async apiAdminDeleteAllMemberFieldsDelete(requestParameters: ApiAdminDeleteAllMemberFieldsDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAdminDeleteAllMemberFieldsDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async apiAdminDeleteAllMembersDeleteRaw(requestParameters: ApiAdminDeleteAllMembersDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.companyId !== undefined) {
            queryParameters['companyId'] = requestParameters.companyId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/DeleteAllMembers`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async apiAdminDeleteAllMembersDelete(requestParameters: ApiAdminDeleteAllMembersDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAdminDeleteAllMembersDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiAdminGenerateInvoicePdfPostRaw(requestParameters: ApiAdminGenerateInvoicePdfPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/GenerateInvoicePdf`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiAdminDtoInvoiceGenerationRequestToJSON(requestParameters.webApiAdminDtoInvoiceGenerationRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiAdminGenerateInvoicePdfPost(requestParameters: ApiAdminGenerateInvoicePdfPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAdminGenerateInvoicePdfPostRaw(requestParameters, initOverrides);
    }

    /**
     * Gets all OneFront users
     */
    async apiAdminGetAllUsersGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiAdminDtoUserListResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/GetAllUsers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiAdminDtoUserListResultDtoFromJSON(jsonValue));
    }

    /**
     * Gets all OneFront users
     */
    async apiAdminGetAllUsersGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiAdminDtoUserListResultDto> {
        const response = await this.apiAdminGetAllUsersGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Updates the Ping Payments tenant configuration (e.g. refund callback URL)
     */
    async apiAdminGetTenantGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/GetTenant`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantResponseFromJSON(jsonValue));
    }

    /**
     * Updates the Ping Payments tenant configuration (e.g. refund callback URL)
     */
    async apiAdminGetTenantGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantResponse> {
        const response = await this.apiAdminGetTenantGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async apiAdminSetNewSubscriptionLevelPostRaw(requestParameters: ApiAdminSetNewSubscriptionLevelPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.companyId !== undefined) {
            queryParameters['companyId'] = requestParameters.companyId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/SetNewSubscriptionLevel`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiAdminDtoSetSubscriptionDtoToJSON(requestParameters.webApiAdminDtoSetSubscriptionDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async apiAdminSetNewSubscriptionLevelPost(requestParameters: ApiAdminSetNewSubscriptionLevelPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAdminSetNewSubscriptionLevelPostRaw(requestParameters, initOverrides);
    }

    /**
     * Set user
     */
    async apiAdminSetUserAsAdminPostRaw(requestParameters: ApiAdminSetUserAsAdminPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/SetUserAsAdmin`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiAdminDtoSetUserAsAdminDtoToJSON(requestParameters.webApiAdminDtoSetUserAsAdminDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiServicesDataTransferObjectsUserServiceAuthenticateResDtoFromJSON(jsonValue));
    }

    /**
     * Set user
     */
    async apiAdminSetUserAsAdminPost(requestParameters: ApiAdminSetUserAsAdminPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto> {
        const response = await this.apiAdminSetUserAsAdminPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the Ping Payments tenant configuration (e.g. refund callback URL)
     */
    async apiAdminUpdateTenantPutRaw(requestParameters: ApiAdminUpdateTenantPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/UpdateTenant`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequestToJSON(requestParameters.webApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequest),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Updates the Ping Payments tenant configuration (e.g. refund callback URL)
     */
    async apiAdminUpdateTenantPut(requestParameters: ApiAdminUpdateTenantPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.apiAdminUpdateTenantPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
